import "./form.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import keyConstants from "../../constants/keyConstants";
import preprocessorQuery from "../../utils/preprocessorQuery";
import Icon from "../interface/Icon";

export default class FormRadio extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = { isChecked: false };
    this.toggle = this.toggle.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentWillMount() {
    const checked = Boolean(this.props.isChecked);
    this.setState({ isChecked: checked });
  }

  componentWillReceiveProps(nextProps) {
    const checked = Boolean(nextProps.isChecked);
    this.setState({ isChecked: checked });
  }

  toggle() {
    this.setState({ isChecked: true });
    this.props.onChange(true);
  }

  onKeyDown(e) {
    if (e.key === keyConstants.Space && !this.props.disabled) {
      e.stopPropagation();
      e.preventDefault();
      this.toggle();
    }
  }

  render() {
    const stateClass = this.state.isChecked ? "checked" : "";
    const isIos = preprocessorQuery.isIos();

    const classes = ["formRadio", stateClass, this.props.disabled ? "disabled" : "", this.props.label ? "" : "noLabel"];

    return (
      <div
        className={classes.join(" ")}
        onClick={this.props.disabled ? null : this.toggle}
        tabIndex={this.props.disabled ? null : 0}
        onKeyDown={this.onKeyDown}
      >
        <span>
          {isIos && this.props.isChecked ? <Icon icon="radioTick" /> : <Icon icon="radio" />}
          <span className="formRadioLabel">
            {this.props.label}
            {this.props.subLabel ? <span className="formRadioSubLabel">{this.props.subLabel}</span> : null}
          </span>
        </span>
      </div>
    );
  }
}

FormRadio.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};
